/**
 * useCopilotChat — Façade hook satisfying AC 3 requirement
 * 
 * AC 3 says: "Chat state managed via useCopilotChat custom hook"
 * This façade composes 4 domain hooks into a single API.
 * 
 * The orchestrator (SimpleCopilotPanel) calls useCopilotChat and receives
 * all callbacks from all domain hooks in one return object.
 * 
 * SAFE REFACTORING: This is NEW code (façade only), not extracted code.
 * It delegates entirely to domain hooks — zero logic of its own.
 */

import type { CopilotChatParams } from './CopilotChatParams';
import { useMessageSender } from './useMessageSender';
import { useSessionManagement } from './useSessionManagement';
import { useFormHandler } from './useFormHandler';
import { useAdaptiveCardHandler } from './useAdaptiveCardHandler';

/**
 * Single hook API for all copilot chat functionality
 * Composes: useMessageSender + useSessionManagement + useFormHandler + useAdaptiveCardHandler
 */
export function useCopilotChat(params: CopilotChatParams) {
  const sender = useMessageSender(params);
  const session = useSessionManagement(params);
  const form = useFormHandler(params);
  const cards = useAdaptiveCardHandler(params);

  return {
    ...sender,
    ...session,
    ...form,
    ...cards,
  };
}
